// import React, { useEffect, useState } from 'react';
// import { Dropdown } from 'react-bootstrap';
// import chevronLeft from '../../assets/images/Dashboard/chevron-left.svg';
// import chevronRight from '../../assets/images/Dashboard/chevron-right.svg';
// import { loadSettingsHolidayPolicyData } from '../../redux/action';
// import { useDispatch, useSelector } from 'react-redux';

// const HolidaySchedules = () => {

//     const dispatch = useDispatch();
//     const { getHolidayPolicyData } = useSelector((state) => state.data);
//     console.log(getHolidayPolicyData,'getHolidayPolicyData')
//     const [currentDate, setCurrentDate] = useState(new Date());
//     const [activeChevron, setActiveChevron] = useState(null);

//     // Example list of US holidays for 2024
//     const usHolidays = [
//         { date: '2024-01-01', name: 'New Year\'s Day' },
//         { date: '2024-01-15', name: 'Martin Luther King Jr. Day' },
//         { date: '2024-02-19', name: 'Washington\'s Birthday' },
//         { date: '2024-05-27', name: 'Memorial Day' },
//         { date: '2024-07-04', name: 'Independence Day' },
//         { date: '2024-09-02', name: 'Labor Day' },
//         { date: '2024-10-14', name: 'Columbus Day' },
//         { date: '2024-11-11', name: 'Veterans Day' },
//         { date: '2024-11-28', name: 'Thanksgiving Day' },
//         { date: '2024-12-25', name: 'Christmas Day' },
//     ];

//     const getDaysInMonth = (month, year) => new Date(year, month, 0).getDate();
//     const getFirstDayOfMonth = (month, year) => new Date(year, month, 1).getDay();

//     const renderCalendar = (date) => {
//         const month = date.getMonth();
//         const year = date.getFullYear();
//         const daysInMonth = getDaysInMonth(month + 1, year);
//         const firstDay = getFirstDayOfMonth(month, year);

//         const days = [];
//         const dayNames = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

//         // Adding day names
//         dayNames.forEach((dayName, index) => {
//             days.push(
//                 <div className="calendar-date calendar-day-name" key={`day-name-${index}`}>
//                     {dayName}
//                 </div>
//             );
//         });

//         // Adding empty cells for days before the start of the month
//         for (let i = 0; i < firstDay; i++) {
//             days.push(<div className="calendar-date empty" key={`empty-${i}`}></div>);
//         }

//         // Adding actual days of the month
//         for (let day = 1; day <= daysInMonth; day++) {
//             const currentDay = new Date(year, month, day);
//             const formattedDate = currentDay.toISOString().split('T')[0]; // Format as YYYY-MM-DD
//             const isHoliday = usHolidays.some(holiday =>
//                 holiday.date === formattedDate
//             );
//             days.push(
//                 <div
//                     className={`calendar-date ${isHoliday ? 'holiday' : ''}`}
//                     key={`day-${day}`}
//                 >
//                     <div className="calendar-date-day">{day}</div>
//                 </div>
//             );
//         }

//         return days;
//     };

//     const handleChevronClick = (direction) => {
//         setActiveChevron(direction);
//         setCurrentDate(prevDate => {
//             const newDate = new Date(prevDate);
//             if (direction === 'left') {
//                 newDate.setMonth(newDate.getMonth() - 1);
//             } else if (direction === 'right') {
//                 newDate.setMonth(newDate.getMonth() + 1);
//             }
//             return newDate;
//         });
//         // Reset active chevron after changing the date
//         setActiveChevron(null);
//     };

//     useEffect(() => {
//         dispatch(loadSettingsHolidayPolicyData());
//     }, [])

//     return (
//         <div className="barchart-container holiday-schedule-card">
//             <div className="holiday-schedule-card-body">
//                 <div className="holiday-schedule-card-header">
//                     <h6>Holidays Schedules</h6>
//                     <Dropdown>
//                         <Dropdown.Toggle id="dropdown-basic">
//                             Year
//                         </Dropdown.Toggle>
//                         <Dropdown.Menu>
//                             <Dropdown.Item>2024</Dropdown.Item>
//                             <Dropdown.Item>2023</Dropdown.Item>
//                             <Dropdown.Item>2022</Dropdown.Item>
//                         </Dropdown.Menu>
//                     </Dropdown>
//                 </div>

//                 <div className='holiday-schedule-chevron-month-div'>
//                     <div
//                         className={`holiday-schedule-chevron-img ${activeChevron === 'left' ? 'active' : ''}`}
//                         onClick={() => handleChevronClick('left')}
//                     >
//                         <img src={chevronLeft} alt="Previous Month" />
//                     </div>
//                     <h6 className="m-0">{currentDate.toLocaleString('default', { month: 'long' })} {currentDate.getFullYear()}</h6>
//                     <div
//                         className={`holiday-schedule-chevron-img ${activeChevron === 'right' ? 'active' : ''}`}
//                         onClick={() => handleChevronClick('right')}
//                     >
//                         <img src={chevronRight} alt="Next Month" />
//                     </div>
//                 </div>

//                 <div className="calendar-grid">
//                     {renderCalendar(currentDate)}
//                 </div>
//                 <hr />
//                 <div>
//                     <h6>List Of</h6>
//                     <div className="holiday-list">
//                         {usHolidays.map(holiday => (
//                             <div key={holiday.date} className="d-flex align-items-center mb-3">
//                                 <div className="holiday-date">
//                                     <h6 className="m-0">{new Date(holiday.date).getDate()}</h6>
//                                     <small>{new Date(holiday.date).toLocaleDateString('en-US', { weekday: 'short' })}</small>
//                                 </div>
//                                 <div className="ms-3 holiday-names">
//                                     <h6 className="m-0">{holiday.name}</h6>
//                                     <small>{holiday.name}</small>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default HolidaySchedules;



import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import chevronLeft from '../../assets/images/Dashboard/chevron-left.svg';
import chevronRight from '../../assets/images/Dashboard/chevron-right.svg';
import { loadSettingsHolidayPolicyData } from '../../redux/action';
import { useDispatch, useSelector } from 'react-redux';

const HolidaySchedules = () => {
    const dispatch = useDispatch();
    const { getHolidayPolicyData } = useSelector((state) => state.data);
    const [currentDate, setCurrentDate] = useState(new Date());
    const [activeChevron, setActiveChevron] = useState(null);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [loading, setLoading] = useState(false);

    // Convert API data into a simpler array for rendering
    const holidays = (getHolidayPolicyData || []).map(item => ({
        from: new Date(item.HolidayFromDate),
        to: new Date(item.HolidayToDate),
        name: item.HolidayName,
        description: item.Description
    }));

    // Check if a date falls within any holiday range
    const isHolidayDate = (date) => {
        return holidays.some(holiday => {
            const holidayStart = new Date(holiday.from.setHours(0, 0, 0, 0));
            const holidayEnd = new Date(holiday.to.setHours(0, 0, 0, 0));
            return date >= holidayStart && date <= holidayEnd;
        });
    };

    const getDaysInMonth = (month, year) => new Date(year, month, 0).getDate();
    const getFirstDayOfMonth = (month, year) => new Date(year, month, 1).getDay();

    const renderCalendar = (date) => {
        const month = date.getMonth();
        const year = date.getFullYear();
        const daysInMonth = getDaysInMonth(month + 1, year);
        const firstDay = getFirstDayOfMonth(month, year);

        const days = [];
        const dayNames = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

        // Day headers
        dayNames.forEach((dayName, index) => {
            days.push(
                <div className="calendar-date calendar-day-name" key={`day-name-${index}`}>
                    {dayName}
                </div>
            );
        });

        // Empty cells before the first day
        for (let i = 0; i < firstDay; i++) {
            days.push(<div className="calendar-date empty" key={`empty-${i}`}></div>);
        }

        // Actual days
        for (let day = 1; day <= daysInMonth; day++) {
            const currentDay = new Date(year, month, day);
            const holiday = isHolidayDate(currentDay);
            days.push(
                <div
                    className={`calendar-date ${holiday ? 'holiday' : ''}`}
                    key={`day-${day}`}
                >
                    <div className="calendar-date-day">{day}</div>
                </div>
            );
        }

        return days;
    };

    const handleChevronClick = (direction) => {
        setActiveChevron(direction);
        setCurrentDate(prevDate => {
            const newDate = new Date(prevDate);
            if (direction === 'left') {
                newDate.setMonth(newDate.getMonth() - 1);
            } else if (direction === 'right') {
                newDate.setMonth(newDate.getMonth() + 1);
            }
            return newDate;
        });
        setActiveChevron(null);
    };

    // Function to generate year range from startYear to current year
    function generateYearRange(startYear) {
        const currentYear = new Date().getFullYear(); // Get current year dynamically
        const years = [];

        // Generate years from startYear to currentYear
        for (let year = startYear; year <= currentYear; year++) {
            years.push({ value: year, label: year });
        }

        return years;
    }

    const yearOptions = generateYearRange(2024); // Generate years from 2022 to the current year

    useEffect(() => {
        setLoading(true);
        dispatch(loadSettingsHolidayPolicyData(setLoading, null, null, null, selectedYear));
    }, [dispatch, selectedYear]);

    const handleYearChange = (year) => {
        setSelectedYear(year);
    };

    return (
        <div className="barchart-container holiday-schedule-card">
            <div className="holiday-schedule-card-body">
                <div className="holiday-schedule-card-header">
                    <h6>Holidays Schedules</h6>
                    <Dropdown onSelect={handleYearChange}>
                        <Dropdown.Toggle id="dropdown-basic">
                            {selectedYear}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {yearOptions.map((year) => (
                                <Dropdown.Item key={year.value} eventKey={year.value}>
                                    {year.label}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <div className='holiday-schedule-chevron-month-div'>
                    <div
                        className={`holiday-schedule-chevron-img ${activeChevron === 'left' ? 'active' : ''}`}
                        onClick={() => handleChevronClick('left')}
                    >
                        <img src={chevronLeft} alt="Previous Month" />
                    </div>
                    <h6 className="m-0">
                        {currentDate.toLocaleString('default', { month: 'long' })} {currentDate.getFullYear()}
                    </h6>
                    <div
                        className={`holiday-schedule-chevron-img ${activeChevron === 'right' ? 'active' : ''}`}
                        onClick={() => handleChevronClick('right')}
                    >
                        <img src={chevronRight} alt="Next Month" />
                    </div>
                </div>

                <div className="calendar-grid">
                    {renderCalendar(currentDate)}
                </div>
                <hr />
                <div>
                    <h6>List Of</h6>
                    <div className="holiday-list">
                        {holidays.map((holiday, index) => (
                            <div key={index} className="d-flex align-items-center mb-3">
                                <div className="holiday-date">
                                    <h6 className="m-0">{holiday.from.getDate()}</h6>
                                    <small>{holiday.from.toLocaleDateString('en-US', { weekday: 'short' })}</small>
                                </div>
                                <div className="ms-3 holiday-names">
                                    <h6 className="m-0">{holiday.name}</h6>
                                    <small>{holiday.description}</small>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HolidaySchedules;

